import styled from 'styled-components'
import { Box } from '@mui/material'

export const ContainerWorkout = styled(Box)`
  padding: 2px 4px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  margin-top: 2px;
  justify-content: center;
`
